import GeoJSON from 'ol/format/GeoJSON';
import { Projection } from 'ol/proj';
import { RateLimiter } from '@shared/utils/rate-limiter';
import { createXYZ, extentFromProjection } from 'ol/tilegrid';

const projection = 'EPSG:3857';
const GEOJSON_FORMAT = new GeoJSON({
    featureProjection: projection,
});

const extent = extentFromProjection(projection);
const tileGrid = createXYZ({
    extent: extent,
    maxZoom: 22,
    tileSize: 512,
});

const VECTOR_TILE_FORMAT = new GeoJSON({
    // Data returned from geojson-vt is in tile pixel units
    dataProjection: new Projection({
        code: 'TILE_PIXELS',
        units: 'tile-pixels',
        extent: [0, 0, 4096, 4096],
    }),
});
const MAX_RADIAN_VALUE = Math.PI * 2;
const rateLimiter = new RateLimiter(10, 15);

type DrawingConfig = {
    tileMinZoom: number;
    tileMaxZoom: number;
    rasterMinZoom: number;
    rasterMaxZoom: number;
    polygonMinZoom: number;
    polygonMaxZoom: number;
    textMinZoom: number;
    textMaxZoom: number;
};

const MOBILE_CONFIG: DrawingConfig = {
    tileMinZoom: 15,
    tileMaxZoom: 27,
    rasterMinZoom: 1,
    rasterMaxZoom: 20,
    polygonMinZoom: 18,
    polygonMaxZoom: 27,
    textMinZoom: 17,
    textMaxZoom: 27,
};

const DESKTOP_CONFIG: DrawingConfig = {
    tileMinZoom: 16,
    tileMaxZoom: 27,
    rasterMinZoom: 1,
    rasterMaxZoom: 16,
    polygonMinZoom: 17,
    polygonMaxZoom: 27,
    textMinZoom: 17,
    textMaxZoom: 27,
};

export const DrawingUtils = {
    GEOJSON_FORMAT,
    VECTOR_TILE_FORMAT,
    rateLimiter,
    MAX_RADIAN_VALUE,
    tileGrid,
    projection,
    extent,
    MOBILE_CONFIG,
    DESKTOP_CONFIG,
};
